import React, { useEffect, useState } from "react";
import Logo from "./assets/svg/logo";
import "./App.css";
import ArrowBackIcon from "./assets/svg/arrow-back";

function App() {
  // State to hold updated APIs
  const [apis, setApis] = useState([
    {
      title: "CURP",
      endpointId: "48662deb-c14d-453e-9784-70832a7605e0",
      status: Array(30).fill(0)  // Pre-filled with 0
    },
    {
      title: "INE / IFE / PASAPORTE",
      endpointId: "05c6fc42-c8c6-462d-9448-118800749b92",
      status: Array(30).fill(0)  // Pre-filled with 0
    },
    {
      title: "EMAIL",
      endpointId: "a6cc88ec-6a7a-4b98-9274-f9645a50d062",
      status: Array(30).fill(0)  // Pre-filled with 0
    },
    {
      title: "PHONE",
      endpointId: "1f581de8-53db-4f27-80ed-3a3afd327f9c",
      status: Array(30).fill(0)  // Pre-filled with 0
    },
    {
      title: "IP",
      endpointId: "9dc41379-1865-4415-9eb0-a9a5bb454368",
      status: Array(30).fill(0)  // Pre-filled with 0
    }
  ]);

  const [loading, setLoading] = useState(true);  // Loading state

  const status = ["shutdown", "unstable", "operational"];

  // Fetch API data on component mount
  useEffect(() => {
    fetch("https://u439lq97h7.execute-api.us-west-2.amazonaws.com/dev/status")
      .then((response) => response.json())
      .then((data) => {
        // Update apis state with the fetched data
        const updatedApis = apis.map((api) => {
          const apiData = data.find((item) => item.EndPointId === api.endpointId);
          return apiData
            ? {
              ...api,
              status: apiData.success_percentage
            }
            : api;
        });
        console.log(updatedApis)
        setApis(updatedApis);
        setLoading(false);  // Set loading to false after data is fetched
      })
      .catch((error) => {
        console.error("Error fetching API data:", error);
        setLoading(false);  // Ensure loading is stopped even in case of error
      });
  }, []);

  const calculateAverage = (arr) => {
    const percentageMapping = { 2: 100, 1: 50, 0: 0 };
    const percentages = arr.map((value) => percentageMapping[value]);
    const total = percentages.reduce((sum, current) => sum + current, 0);
    const average = (total / arr.length).toFixed(1);
    return average;
  };

  function getDate30DaysAgo() {
    const currentDate = new Date();
    const pastDate = new Date();
    pastDate.setDate(currentDate.getDate() - 15);
    const day = pastDate.getDate();
    const monthNames = [
      "January", "February", "March", "April", "May", "June", "July",
      "August", "September", "October", "November", "December"
    ];
    const month = monthNames[pastDate.getMonth()];
    return `${day} ${month}`;
  }

  function getNearestFiveMinuteTimeAndTimeLeft() {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const roundedMinutes = Math.floor(minutes / 5) * 5;
    const formattedHours = hours.toString().padStart(2, "0");
    const formattedMinutes = roundedMinutes.toString().padStart(2, "0");
    const formattedTime = `${formattedHours}:${formattedMinutes}:00`;
    const minutesLeft = 5 - (minutes % 5) - (seconds > 0 ? 1 : 0);
    const secondsLeft = 60 - seconds;
    let timeLeft;
    if (minutesLeft > 0) {
      timeLeft = `${minutesLeft} minute${minutesLeft > 1 ? "s" : ""}`;
    } else {
      timeLeft = `${secondsLeft} second${secondsLeft > 1 ? "s" : ""}`;
    }
    return { nearestFiveMinuteTime: formattedTime, timeLeft: timeLeft };
  }

  const time = getNearestFiveMinuteTimeAndTimeLeft();

  function formatDateToday() {
    const today = new Date();
    const day = today.getDate();
    const year = today.getFullYear();

    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    const month = monthNames[today.getMonth()];

    return `${month} ${day}, ${year}`;
  }

  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];


  return (
    <div className="root">
      <div className="navbar">
        {/* <div className="left_corner">
          <div className="btn btn_pre_icon">
            <ArrowBackIcon />
            <span>Back to marketplace</span>
          </div>
        </div> */}
        <div className="navbar_info_center">
          <span className="dark">{formatDateToday()}</span>
          <span>|</span>
          <span>Last update: <span className="dark">{time.nearestFiveMinuteTime}</span></span>
          <span>|</span>
          <span>Next update, {time.timeLeft} later</span>
        </div>
        {/* <div className="right_corner">
          <div className="btn btn_link">
            <span>
              Report an issue
            </span>
          </div>
        </div> */}
      </div>

      <div className="main">
        <div className="title">
          <Logo />
          <h1>API Status</h1>
        </div>
        <div className={loading ? "cards cards_loading" : "cards"}>
          {apis.map((api) => (
            <div className="card" key={api.endpointId}>
              <div className="card_title">
                <h2>{api.title}</h2>
                {/* Apply logic to status_indicator */}
                <span className={"status_indicator status_indicator_" +
                  (api.status[api.status.length - 1] < 50 ? 0 : api.status[api.status.length - 1] < 75 ? 1 : 2)}>
                  {status[api.status[api.status.length - 1] < 50 ? 0 : api.status[api.status.length - 1] < 75 ? 1 : 2]}
                </span>
              </div>
              <div className="card_section_title">
                <h3>Uptime</h3>
                <span>{(api.status.reduce((acc, value) => acc + value, 0) / api.status.length).toFixed(2)}% - No current issue</span>
              </div>
              <div className="status_bars">
                {api.status.map((statu, index) => {
                  const date = new Date();
                  date.setDate(date.getDate() - (api.status.length - 1 - index));

                  // Manually format the date as "DD Month"
                  const formattedDate = `${String(date.getDate()).padStart(2, '0')} ${months[date.getMonth()]}`;

                  return (
                    <div key={index} className={"status_item status_item_" +
                      (statu < 50 ? 0 : statu < 75 ? 1 : 2)}>
                      <div className="status_item_popup">
                        <span>{formattedDate}:</span>
                        <span>{statu}%</span>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="status_bars_axis">
                <span>30 days ago</span>
                <span>{getDate30DaysAgo()}</span>
                <span>Today</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default App;
